import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { BarChart3, Database, TrendingUp, BrainCircuit } from "lucide-react";
import analyticsBanner from "../../../images/webtechhome/web-development.jpg";

const trustMetrics = [
  { value: 200, suffix: "+", label: "Analytics Projects", icon: BarChart3 },
  { value: 120, suffix: "+", label: "Enterprise Clients", icon: Database },
  { value: 40, suffix: "%", label: "Avg. Efficiency Gain", icon: TrendingUp },
  { value: 98, suffix: "%", label: "Data Accuracy", icon: BrainCircuit },
];

const DaHero: React.FC = () => (
  <section className="da-hero" aria-labelledby="da-hero-title">
    <div className="da-hero__mesh" aria-hidden="true" />
    <div className="da-particles" aria-hidden="true">
      {Array.from({ length: 18 }, (_, i) => (
        <span key={i} />
      ))}
    </div>

    <div className="da-container da-hero__grid">
      <motion.div
        className="da-hero__content"
        initial={{ opacity: 0, y: 28 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      >
        <span className="da-eyebrow">
          <BarChart3 size={14} aria-hidden="true" />
          Data Analytics Services
        </span>

        <h1 id="da-hero-title">
          Turn Raw Data Into{" "}
          <span className="da-gradient-text">Actionable Insights</span> &amp;{" "}
          <span className="da-gradient-text">Smarter Decisions</span>
        </h1>

        <p>
          From business intelligence dashboards to predictive analytics and AI
          models — we help organizations unlock the full value of their data for
          growth, efficiency, and competitive advantage.
        </p>

        <div className="da-hero__actions">
          <Link className="da-btn da-btn--primary" to="/contact">
            Get Free Consultation
            <ArrowIcon />
          </Link>
          <Link className="da-btn da-btn--ghost" to="/project">
            View Case Studies
            <ArrowIcon />
          </Link>
        </div>

        <div className="da-hero__metrics">
          {trustMetrics.map((metric) => {
            const Icon = metric.icon;
            return (
              <div className="da-metric" key={metric.label}>
                <span className="da-metric__icon" aria-hidden="true">
                  <Icon size={18} />
                </span>
                <strong>
                  <CountUp end={metric.value} duration={2.2} enableScrollSpy scrollSpyOnce />
                  {metric.suffix}
                </strong>
                <span>{metric.label}</span>
              </div>
            );
          })}
        </div>
      </motion.div>

      <div className="da-hero__visual">
        <motion.div
          className="da-hero__banner-wrap"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.15, ease: "easeOut" }}
        >
          <img
            src={analyticsBanner}
            alt="Data analytics dashboard with charts, KPIs, and business intelligence metrics"
            className="da-hero__banner"
          />
        </motion.div>
      </div>
    </div>
  </section>
);

const ArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M3 8h10M9 4l4 4-4 4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DaHero;
